import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/eggs_hero.jpg';
import imgHeroMobile from './i/mobile/eggs_hero.jpg';
import eggsSvg from './i/svg/eggs_stamp.svg';
import eggsSvgFr from './i/svg/eggs_stamp_fr.svg';
import arrow from '../../../../assets/images/hero-arrow.png';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_eggs_1.jpg';
import slide2 from './i/carousel_eggs_2.jpg';
import slide3 from './i/carousel_eggs_3.jpg';
import slide4 from './i/carousel_eggs_4.jpg';
import slide5 from './i/carousel_eggs_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Eggs = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food eggs">
                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="eggs" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="eggs" />
                    }
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    {props.lang === 'en' ? <img className="img-svg" src={eggsSvg} alt={"eggs"} /> : <img className="img-svg" src={eggsSvgFr} alt={"eggs"} /> }
                    {props.lang === 'en' && <p>At A&W, all of our breakfasts begin with freshly cracked eggs, made just the way you like them. They’re farmed right here in Canada, from hens fed a fully vegetarian diet without animal by-products.</p>}
                    {props.lang === 'fr' && <p>Chez A&W, nos déjeuners sont faits avec des œufs fraîchement craqués, préparés comme vous les aimez. Ils proviennent d’élevages canadiens où les poules sont nourries de manière exclusivement végétarienne, sans aucun sous-produit animal.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                {props.lang !== 'fr' ?
                    <>
                        <h2>Where do our&nbsp;  
                            <span>eggs come from?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où viennent nos&nbsp;  
                            <span>œufs?</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt=""  /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>100% CANADIAN</h3>
                                        <p>We’re proud to work with Canadian egg farmers, like the Vanderkooi family in Mission, BC.</p>
                                    </>
                                :
                                    <>
                                        <h3>100 % CANADIENS</h3>
                                        <p>Nous sommes fiers de travailler avec des producteurs d’œufs canadiens, comme la famille Vanderkooi de la Colombie-Britannique.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>ENRICHED HOUSING</h3>
                                        <p>All our hens are raised in enriched-colony housing, which gives them significantly more space, greater access to fresh food and water, the ability to perch freely and the opportunity to lay eggs in their nesting areas.</p>
                                    </>
                                :
                                    <>
                                        <h3>DES POULAILLERS AMÉNAGÉS</h3>
                                        <p>Toutes nos poules sont élevées dans des poulaillers aménagés qui leur offrent plus d’espace, un meilleur accès à de l’eau et de la nourriture fraîches et la possibilité de se percher librement et de pondre dans leurs aires de nidification.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>CLEAN DIET</h3>
                                        <p>Their diet is an all-vegetarian mix of grains and seeds such as corn, wheat, barley and soy.</p>
                                    </>
                                :
                                    <>
                                        <h3>ALIMENTATION SAINE</h3>
                                        <p>Leur régime, complètement végétarien, est composé d’un mélange de céréales comme le maïs, le blé, l’orge et le soya.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>DELIVERED FRESH</h3>
                                        <p>Our eggs are delivered to every A&W Restaurant at least once a week to ensure they’re as fresh as possible.</p>
                                    </>
                                :
                                    <>
                                        <h3>FRAÎCHEMENT LIVRÉS</h3>
                                        <p>Nos œufs sont livrés dans tous nos restaurants A&W au moins une fois par semaine pour assurer qu’ils sont aussi frais que possible.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>EGGS YOUR WAY</h3>
                                        <p>Sit down to a plated breakfast with eggs cooked to order or grab a Bacon & Egger® on the go, any time of the day.</p>
                                    </>
                                :
                                    <>
                                        <h3>FRAÎCHEMENT CASSÉS</h3>
                                        <p>Asseyez-vous le matin devant une assiette déjeuner avec des œufs comme vous les aimez. Ou commandez un Chef-d’œuf™ pour emporter à toute heure de la journée.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </SliderWrap>

            <div className="blockwrap our-food faq-block eggs">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/breakfast`}>
                    {props.lang !== 'fr' ? 
                        <><span>Eggs</span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ sur nos</span> œufs<Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="eggs" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Eggs;